
const Footer = () => {
    return (
        <footer>
            <div>
                <p>&copy; {new Date().getFullYear()} topherhook.com. All rights reserved.</p>
            </div>
        </footer>
    )
}

export default Footer
